import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";
import { GALLERY } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const Gallery = ({ full = false }) => {
  const items = full ? GALLERY : GALLERY.slice(0, 6);
  return (
    <section data-testid="gallery" className="relative border-t border-white/10 py-24 md:py-32">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <Reveal className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div>
            <div className="mb-4 flex items-center gap-3">
              <span className="h-px w-10 bg-brand-cyan" />
              <span className="font-mono text-xs uppercase tracking-[0.25em] text-brand-cyan">Project Gallery</span>
            </div>
            <h2 className="max-w-2xl font-display text-4xl font-extrabold leading-[0.98] tracking-tight md:text-5xl">
              An engineering portfolio, not a photo album.
            </h2>
          </div>
          {!full && (
            <Link to="/projects" data-testid="view-all-projects" className="group flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-white transition-colors hover:text-brand-cyan">
              View All Projects <ArrowUpRight size={14} weight="bold" className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          )}
        </Reveal>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {items.map((g, i) => (
            <motion.div key={g.title + i} data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
              className={`group relative aspect-[4/5] overflow-hidden border border-white/10 ${i === 0 ? "lg:col-span-2 lg:aspect-auto" : ""}`}>
              <img src={g.image} alt={g.title} className="h-full w-full object-cover grayscale transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent opacity-90 transition-opacity group-hover:opacity-80" />
              <div className="absolute inset-x-0 bottom-0 p-6 md:p-7">
                <span className="border border-white/20 bg-ink/60 px-2.5 py-1 font-mono text-[10px] uppercase tracking-widest text-brand-cyan backdrop-blur-sm">{g.tag}</span>
                <h3 className="mt-3 font-display text-xl font-bold text-white">{g.title}</h3>
                <p className="mt-1 translate-y-1 font-mono text-[11px] uppercase tracking-wide text-slatex-300 opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">{g.spec}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
